
(function (backOffice, $) {
    backOffice.Ajax = (function (id) {

        const forbiddenUrl = '/Admin/Forbidden.asp';
        const unauthorizedUrl = '/default.asp';
        const unavailableUrl = '/Admin/SystemUnavailable.asp';

        var redirect = function(url){
            window.location.href = url;
        }

        var initialize = function () {
            $( document ).ajaxError(function( event, request, settings ) {
                switch (request.status) {
                    case 401: 
                        redirect(unauthorizedUrl);
                        break;
                    case 403: 
                        redirect(forbiddenUrl);
                        break;
                    case 503:
                        redirect(unavailableUrl);
                        break;
                }
            });
        };

        return $.extend(backOffice.Ajax, {
            Init: initialize
        });
    })();

    return backOffice.Ajax;
})(BackOffice || {}, jQuery);